module.exports = __webpack_public_path__ + "img/ic_referralprogram.67b3981a.svg";